<nz-form-control *ngIf="recordProperty !== undefined">
  <nz-input-number
  [class]="parentClass"
  #numberField [nzFormatter]="formatterPercent" nzMin="0" [name]="sectionTagName+'.' +field.FieldName"
    nz-input [(ngModel)]="recordProperty.ValueAsObject" [ngModelOptions]="{ updateOn: 'blur'}"
    (ngModelChange)="valueChanged()" [nzDisabled]="recordProperty.ReadOnly" [nzMax]="recordProperty.MaxValue"
    [nzParser]="numberParser" [nzMin]="recordProperty.MinValue" nz-tooltip
    [nzTooltipTitle]="recordProperty.MinValue !== undefined || recordProperty.MaxValue !== undefined || recordProperty.MinValueToolTip !== undefined || recordProperty.MaxValueToolTip !== undefined ? tooltip : undefined">
  </nz-input-number>
  <ng-template #tooltip>
    <span *ngIf="recordProperty.MinValue !== undefined || recordProperty.MinValueToolTip !== undefined">
      {{'Min. ' | locale}}
      {{ (recordProperty.MinValueToolTip !== undefined) ? recordProperty.MinValueToolTip : recordProperty.MinValue}}
    </span>
    <span *ngIf="recordProperty.MaxValue !== undefined || recordProperty.MaxValueToolTip !== undefined">
      <nz-divider *ngIf="recordProperty.MinValue !== undefined"></nz-divider>
      {{'Max. ' | locale}}
      {{ (recordProperty.MaxValueToolTip !== undefined) ? recordProperty.MaxValueToolTip : recordProperty.MaxValue}}
    </span>
  </ng-template>
</nz-form-control>
